import React, { useState } from 'react';
import CardCommon from '@/pages/opinion/components/CardCommon';
import ChannelsLanguageChart from '../../../Performance/components/ChannelsLanguageChart';
import { mentionsIconsMap } from '../../constants';
import { useDrilldownParams } from '@op/hooks/useDrilldownParams';
import { useHistory, useIntl } from 'umi';
import { isStatsDetail } from '../../utils';
import BubbleCommon, {
  keywordTipsMentionsText,
  topicTipsMentionsText,
} from '@/pages/opinion/components/BubbleCommon';

const titleMap: any = {
  topic: 'Top 15 Topics',
  keyword: 'Top 10 Mentions',
};

export default function MentionsCharts({
  data,
  filter,
  loading,
  dataType,
  isVersion,
  gameInfoDetail,
  lang,
  handleStatsDetailOnClick,
  type = 'pie',
  regionType,
  defaultSelected,
  chartOptions,
}: any) {
  const statsDetailType = 'stats-mentions';
  const history = useHistory();
  const { goPage } = useDrilldownParams();

  const [activeMentions, setActiveVersionMentions] = useState<
    'pie' | 'coordinate'
  >(type);

  const { formatMessage } = useIntl();

  const isDetail = isStatsDetail(history);

  const tipsMap: any = {
    keyword: keywordTipsMentionsText,
    topic: topicTipsMentionsText,
  };

  return (
    <CardCommon
      title={
        <BubbleCommon
          showIcon={['topic', 'keyword'].includes(dataType)}
          tipsMap={tipsMap[dataType] || null}
        >
          {formatMessage({ id: titleMap[dataType] || 'Mentions' })}
        </BubbleCommon>
      }
      hasTitleArrow={!isDetail}
      handleTitleOnClick={() => {
        if (isDetail) return;
        goPage({
          path: '/opinion/Stats/Detail',
          filter: {
            filter,
            statsDetailType,
            statsDetailChartsData: {
              data,
              dataType,
              isVersion,
              regionType,
            },
          },
        });
      }}
      bodyStyle={{ height: 375 }}
      defaultOperation={activeMentions}
      operations={mentionsIconsMap[dataType] || []}
      handleOperationsOnClick={(item) => {
        setActiveVersionMentions(item.symbol as any);
      }}
    >
      <ChannelsLanguageChart
        dataType={dataType}
        data={data}
        lang={lang}
        filter={filter}
        loading={loading}
        type={activeMentions}
        defaultSelected={defaultSelected}
        chartOptions={chartOptions}
        height={activeMentions === 'coordinate' ? 270 : 300}
        isVersion={isVersion}
        gameInfoDetail={gameInfoDetail}
        statsDetailType={statsDetailType}
        handleStatsDetailOnClick={handleStatsDetailOnClick}
        regionType={regionType}
      ></ChannelsLanguageChart>
    </CardCommon>
  );
}
